import { render, staticRenderFns } from "./ProfileTabs.vue?vue&type=template&id=258b04c4&scoped=true&"
import script from "./ProfileTabs.vue?vue&type=script&lang=ts&"
export * from "./ProfileTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileTabs.vue?vue&type=style&index=0&id=258b04c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258b04c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
